import axios from 'axios'
import { LOGIN_USER, LOGIN_USER_SUCCESS, LOGIN_USER_FAIL, LOGOUT_USER } from './types'
import { URL } from '../const'

export const loginUser = (mail_address, password) => async dispatch => {
  dispatch({ type: LOGIN_USER })

  try {
    const res = await axios({
      method: 'post',
      url: `${URL}login`,
      data: {
        mail_address,
        password
      },
      headers: {
        'Content-type': 'application/x-www-form-urlencoded'
      }
    })
    // console.log('res: ', res)
    const { name, token, user_role, owner_id } = res.data
    const expireDuration = 3600 // 1h
    let expiresAt = JSON.stringify((expireDuration * 1000) + new Date().getTime())
    localStorage.setItem('name', name)
    localStorage.setItem('owner_id', owner_id)
    localStorage.setItem('user_role', user_role)
    localStorage.setItem('token', token)
    localStorage.setItem('expires_at', expiresAt)

    dispatch({ type: LOGIN_USER_SUCCESS, payload: { token, name, user_role, owner_id } })
  } catch (error) {
    dispatch({ type: LOGIN_USER_FAIL, payload: error })
  }
}

export const logoutUser = (history) => async dispatch => {
  localStorage.removeItem('name')
  localStorage.removeItem('token')
  localStorage.removeItem('owner_id')
  localStorage.removeItem('user_role')
  localStorage.removeItem('expires_at')

  history.push('/')
  dispatch({ type: LOGOUT_USER })
}

export const isAuthenticated = () => dispatch => {
  // Check whether the current time is past the
  // access token's expiry time
  const expiresAt = JSON.parse(localStorage.getItem('expires_at'))
  const name = localStorage.getItem('name')
  const user_role = localStorage.getItem('user_role')
  const owner_id = localStorage.getItem('owner_id')
  const token = localStorage.getItem('token')
  if (new Date().getTime() < expiresAt && token && name && user_role) {
    dispatch({ type: LOGIN_USER_SUCCESS, payload: { name, token, user_role, owner_id } })
  } else {
    localStorage.removeItem('name')
    localStorage.removeItem('token')
    localStorage.removeItem('owner_id')
    localStorage.removeItem('user_role')
    localStorage.removeItem('expires_at')
    return {
      type: LOGIN_USER_FAIL,
      payload: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js